import { Icon } from "@/components/icons/Icon";
import { IconButton } from "@/components/interactive/IconButton";
import { classNames } from "@/utils/classnames";
import React, { PropsWithChildren, ReactNode } from "react";

export interface CollapsibleWarningBannerProps extends PropsWithChildren {
  className: string;
  onCollapse?: () => void;
  title: ReactNode;
}

export const CollapsibleWarningBanner: React.FC<CollapsibleWarningBannerProps> = ({
  children,
  className,
  onCollapse,
  title,
}) => {
  return (
    <div className={classNames("relative px-5 py-2 text-cds-sm", className)}>
      <div className="pr-7">
        <div className="font-medium">{title}</div>
        {children}
      </div>
      {onCollapse && (
        <IconButton
          aria-label="Collapse warning banners"
          className="absolute right-1 top-1 border-current text-current outline-current hover:bg-current/10 focus:bg-current/10 active:bg-current/20"
          color="white"
          iconName="close"
          onClick={onCollapse}
          size="sm"
        />
      )}
    </div>
  );
};

export interface CollapsedWarningPillProps {
  className: string;
  label: string;
  onClick: () => void;
}

export const CollapsedWarningPill: React.FC<CollapsedWarningPillProps> = ({
  className,
  label,
  onClick,
}) => {
  return (
    <button
      aria-label={`Expand ${label}`}
      type="button"
      className={classNames(
        "pointer-events-auto inline-flex gap-x-1 items-center rounded-full border-[1px] px-2.5 py-1",
        "max-w-[140px] whitespace-nowrap text-[11px] font-medium leading-none shadow-sm backdrop-blur-sm transition-[color,background-color,border-color,filter]",
        className,
      )}
      onClick={onClick}
    >
      <Icon name={"warning"} size={"sm"} />
      {label}
    </button>
  );
};
